module.exports = __webpack_public_path__ + "static/media/delete.586831df.svg";